export enum VehicleFuelTypeEnum {
  NA = 0,
  FUEL_95 = 1,
  FUEL_98 = 2,
  DIESEL = 3,
  DIESEL_PREMIUM = 4,
  HYBRID = 5,
  ELECTRIC = 6,
  NATURAL_GAS = 7,
  FUEL_95E10 = 8,
  OTHER = 20,
}

export const VehicleFuelLabelKeys: Record<VehicleFuelTypeEnum, string> = {
  [VehicleFuelTypeEnum.NA]: 'common.fuel_labels.NA',
  [VehicleFuelTypeEnum.FUEL_95]: 'common.fuel_labels.FUEL_95',
  [VehicleFuelTypeEnum.FUEL_98]: 'common.fuel_labels.FUEL_98',
  [VehicleFuelTypeEnum.DIESEL]: 'common.fuel_labels.DIESEL',
  [VehicleFuelTypeEnum.DIESEL_PREMIUM]: 'common.fuel_labels.DIESEL_PREMIUM',
  [VehicleFuelTypeEnum.HYBRID]: 'common.fuel_labels.HYBRID',
  [VehicleFuelTypeEnum.ELECTRIC]: 'common.fuel_labels.ELECTRIC',
  [VehicleFuelTypeEnum.NATURAL_GAS]: 'common.fuel_labels.NATURAL_GAS',
  [VehicleFuelTypeEnum.FUEL_95E10]: 'common.fuel_labels.FUEL_95E10',
  [VehicleFuelTypeEnum.OTHER]: 'common.fuel_labels.OTHER',
};
